export default __webpack_public_path__ + "static/media/homeoffice.0fd6a98e.svg";